var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddpicsvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 41,
    viewBox: "0 0 44 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36 34H4C1.8 34 0 32.2 0 30V4C0 1.8 1.8 0 4 0H36C38.2 0 40 1.8 40 4V30C40 32.2 38.2 34 36 34Z",
    fill: "#0877BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31 12C32.6569 12 34 10.6569 34 9C34 7.34315 32.6569 6 31 6C29.3431 6 28 7.34315 28 9C28 10.6569 29.3431 12 31 12Z",
    fill: "#E0F5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 9L5 25H27L16 9Z",
    fill: "#E0F5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27 15L19 25H35L27 15Z",
    fill: "#E0F5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34 41C39.5228 41 44 36.5228 44 31C44 25.4772 39.5228 21 34 21C28.4772 21 24 25.4772 24 31C24 36.5228 28.4772 41 34 41Z",
    fill: "#0877BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32 25H36V37H32V25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28 29H40V33H28V29Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddpicsvg);
export default __webpack_public_path__ + "static/media/addpicsvg.6d56fe7f815d57ee4a6c32935d549641.svg";
export { ForwardRef as ReactComponent };